import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewCs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m12.476 1.695 1.263.551.45.196.068.486.47 3.388.844 2.026 1.35 1.092.16.128.085.185.615 1.328.02.041.014.042.202.586.437.2.403.185.09.434.195.94.088.429-.29.328c-.013.014-1.303 1.472-2.626 3.062-2.46 2.958-2.764 3.636-2.798 3.739l-.428 1.439-1.042-1.082c-2.805-2.913-6.057-6.12-6.643-6.441L4.5 14.51l.595-.823.73-1.011.385-1.983.039-.202.125-.164.97-1.263.926-3.211.043-.146.087-.123 2.172-3.015.088-.123.124-.085.843-.584.401-.277.448.195Zm2.572 11.695-1.756 1.675.93.15 1.333-.048.854-1.345-.136-1.771-1.225 1.339Zm-7.031.898.992.835H11.2l-2.922-2.817-.261 1.982Z"
    />
  </svg>
);
